export default __webpack_public_path__ + "static/media/granite_96x96.f8ebf28b.png";